module.exports = __webpack_public_path__ + "img/HRS_Virtual_Training_Logo.1e1d6ab3.png";